class VendorPorsiEntity {
    id: number
    id_vendor: number
    id_lokasi: number
    shift: number
    qty_regular: number
    qty_vegetarian: number
    taken_regular_tapping: number
    taken_regular_dropoff: number
    taken_regular_guest: number
    taken_vegetarian_tapping: number
    taken_vegetarian_dropoff: number
    taken_vegetarian_guest: number
    sisa_regular: number
    sisa_vegetarian: number
    tanggal: Date
    datetime_in: Date
    vendor: string
    lokasi: string

    constructor(object: VendorPorsiEntity) {
        this.id = object.id
        this.id_vendor = object.id_vendor
        this.id_lokasi = object.id_lokasi
        this.shift = object.shift
        this.qty_regular = object.qty_regular
        this.qty_vegetarian = object.qty_vegetarian
        this.taken_regular_tapping = object.taken_regular_tapping
        this.taken_regular_dropoff = object.taken_regular_dropoff
        this.taken_regular_guest = object.taken_regular_guest
        this.taken_vegetarian_tapping = object.taken_vegetarian_tapping
        this.taken_vegetarian_dropoff = object.taken_vegetarian_dropoff
        this.taken_vegetarian_guest = object.taken_vegetarian_guest
        this.sisa_regular = object.sisa_regular
        this.sisa_vegetarian = object.sisa_vegetarian
        this.tanggal = object.tanggal
        this.datetime_in = object.datetime_in
        this.vendor = object.vendor
        this.lokasi = object.lokasi
    }
}

class AddVendorPorsiEntity {
    id_vendor?: number
    id_lokasi?: number
    shift?: number
    qty_regular?: number
    qty_vegetarian?: number
    tanggal?: Date
    datetime_in?: Date
    vendor?: string
    lokasi?: string

    constructor(object: {
        id_vendor?: number
        id_lokasi?: number
        shift?: number
        qty_regular?: number
        qty_vegetarian?: number
        tanggal?: Date
        datetime_in?: Date
        vendor?: string
        lokasi?: string
    }) {
        this.id_vendor = object.id_vendor
        this.id_lokasi = object.id_lokasi
        this.shift = object.shift
        this.qty_regular = object.qty_regular
        this.qty_vegetarian = object.qty_vegetarian
        this.tanggal = object.tanggal
        this.datetime_in = object.datetime_in
        this.vendor = object.vendor
        this.lokasi = object.lokasi
    }
}

export { VendorPorsiEntity, AddVendorPorsiEntity };